// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-fade-enter-active[data-v-5b8120a9],.slide-fade-leave-active[data-v-5b8120a9]{transition:all .3s ease}.slide-fade-enter[data-v-5b8120a9],.slide-fade-leave-to[data-v-5b8120a9]{opacity:0;transform:translateX(10px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
